var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ma-0 pa-0"},[(_vm.separator)?_c('v-divider'):_vm._e(),_c('v-card-subtitle',{domProps:{"textContent":_vm._s(_vm.title)}}),_c('v-container',{staticStyle:{"max-width":"inherit"}},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }